
import { motion } from "framer-motion";
import { FileEdit, CalendarClock, LineChart } from "lucide-react";
import { useTranslation } from "react-i18next";

const steps = ["create", "schedule", "track"];

const stepIcons = {
  create: FileEdit,
  schedule: CalendarClock,
  track: LineChart
};

export const HowItWorksSection = () => {
  const { t } = useTranslation();
  
  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5 }}
      className="pt-[55px] pb-[80px] px-4 bg-[#8791F3]"
    >
      <h2 className="text-3xl font-bold text-center mb-3 text-[#F1F6F5]">
        {t("howItWorks.title")}
      </h2>
      <p className="text-xl text-[#34375B]/80 mb-8 font-medium">
          {t("howItWorks.subtitle")}
        </p>
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => {
            const Icon = stepIcons[step as keyof typeof stepIcons];
            return (
              <motion.div
                key={step}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 * index }}
                className="flex flex-col items-center text-center p-8 bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300"
              >
                <div className="mb-6 p-4 bg-[#A7DCD8] rounded-full hover:bg-[#5CC2BB] transition-colors">
                  <Icon className="w-8 h-8 text-[#34375B]" />
                </div>
                <h3 className="text-xl font-semibold mb-4 text-[#34375B]">
                  {t(`howItWorks.steps.${step}.title`)}
                </h3>
                <p className="text-base text-[#34375B]/85">
                  {t(`howItWorks.steps.${step}.description`)}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </motion.section>
  );
};
